import {CALL_API} from 'middleware/api';

export const ACTIVATION = 'ACTIVATION';
export const SUCCESS_ACTIVATION = 'SUCCESS_ACTIVATION';
export const FAILURE_ACTIVATION = 'FAILURE_ACTIVATION';

function fetchActivation(data) {
    const {email} = data;
    return {
        type: ACTIVATION,
        [CALL_API]: {
            endpoint: `/api/activation?email=${email}`,
            method: 'get',
            types: [SUCCESS_ACTIVATION, FAILURE_ACTIVATION]
        }
    };
}

export function activation(data) {
    return (dispatch) => {
        dispatch(fetchActivation(data));
    };
}



// WEBPACK FOOTER //
// ./js/actions/auth/ActivationAction.js